export const palletSourceOf = (item) => item?.pallet?.data ?? item?.pallet ?? null;

export const flattenDeclaredPallet = (item) => {
    const source = palletSourceOf(item);
    const raw = source?.pallet_name;
    const declared = typeof raw === 'string' ? raw.trim() : '';
    const pallet_id = item?.pallet_id ?? source?.pallet_id ?? null;
    const warehouse_status = source?.warehouse_status ?? null;

    if (!declared && !pallet_id) {
        const { pallet, ...rest } = item || {};
        return rest;
    }

    return {
        ...item,
        ...(pallet_id ? { pallet_id } : {}),
        pallet: {
            ...(declared ? { pallet_name: declared } : {}),
            ...(pallet_id ? { pallet_id } : {}),
            ...(warehouse_status ? { warehouse_status } : {}),
        },
    };
};
